<div
  class="home-book-widget-desktop flex flex-col gap-24"
  *ngIf="bookWidgetFields && bookWidgetAem"
>
  <div class="flex justify-between gap-24 ultrawide:gap-32">
    <div class="gap-8 ultrawide:gap-12 flex">
      <idp-one-way-route-picker-mach-core
        class="laptop:w-[266px] ultrawide:w-[292px]"
        [routePickerContent]="{
          origin: {
            title: bookWidgetAem.airportsField.from,
            subtitle: bookWidgetAem.airportsField.yourOrigin
          },
          destination: {
            title: bookWidgetAem.airportsField.to,
            subtitle: bookWidgetAem.airportsField.yourDestination
          },
          ariaLabels: {
            origin:
              bookWidgetFields.airportsField.airports[0].fromAirportcode ||
              'Origin Airport or City',
            swapArrow: 'Reverse origin and destination city or airport',
            destination:
              bookWidgetFields.airportsField.airports[0].toAirportcode ||
              'Departure Airport or City'
          }
        }"
        [routePickerCities]="{
          destinationCode:
            bookWidgetFields.airportsField.airports[0].toAirportcode,
          destinationName: bookWidgetFields.airportsField.airports[0].toCity,
          destinationRegion: '',
          originCode:
            bookWidgetFields.airportsField.airports[0].fromAirportcode,
          originName: bookWidgetFields.airportsField.airports[0].fromCity,
          originRegion: ''
        }"
        [routePickerError]="
          bookWidgetFields.airportsField.fieldErrorInfo?.routePickerField
        "
        [recentSearchList]="recentSearchList"
        [savedSearchList]="savedSearchList"
        [searchModalTabs]="searchModalTabs"
        [isFullscreen]="isFullscreen"
        [predictiveSearchData]="predictiveSearchData"
        (swapClicked)="swapClicked.emit(0)"
        (searchModalTriggerClicked)="searchModalTriggerClicked.emit($event)"
        (searchModalEvent)="searchModalEvent.emit($event)"
      ></idp-one-way-route-picker-mach-core>
      <idp-select-mach-core
        id="trip-type-field"
        class="!h-[74px] laptop:w-[195.5px] ultrawide:w-[272px]"
        [title]="bookWidgetAem.tripTypesField.tripTypeAriaLabel"
        [isTitleHidden]="true"
        [disabled]="bookWidgetFields.tripTypesField.disable"
        [dropdownOptions]="bookWidgetFields.tripTypesField.dropdownOptions"
        (selectionChange)="
          onDropdownSelectionChange($event, bookWidgetFieldUpdateTypes.tripType)
        "
      ></idp-select-mach-core>
      <idp-date-picker-mach-core
        class="laptop:w-[195.5px] ultrawide:w-[271px]"
        [selectedTripType]="bookWidgetFields.tripTypesField.selectedTripType"
        [selectedRange]="bookWidgetFields.datesField.dates[0]"
        [bookWidgetAem]="bookWidgetAem"
        [datepickerConfig]="datepickerConfig"
        [fieldErrorInfo]="bookWidgetFields.datesField.fieldErrorInfo?.[0]"
        (selectedDateRange)="
          onDateSelectionChange(
            $event,
            bookWidgetFieldUpdateTypes.datesChange,
            0
          )
        "
      ></idp-date-picker-mach-core>
      <idp-select-mach-core
        class="!h-[74px] laptop:w-[91px] ultrawide:w-[95px]"
        icon="/content/dam/delta-applications/sitewide/capability/flight-shop/images/pax-icon.svg"
        [title]="bookWidgetAem.passengerField.passengerAriaLabel"
        [isTitleHidden]="true"
        [hideDropdownListIcon]="true"
        [disabled]="bookWidgetFields.passengerField.disable"
        [dropdownOptions]="bookWidgetFields.passengerField.dropdownOptions"
        [isVariableWidthDropdown]="true"
        [showValueWhenSelected]="true"
        (selectionChange)="
          onDropdownSelectionChange(
            $event,
            bookWidgetFieldUpdateTypes.passenger
          )
        "
      ></idp-select-mach-core>
    </div>

    <button
      id="findFilghtsCta"
      class="button button-primary button-lg mt-[5px]"
      #findFlightButton
      tabindex="0"
      data-acdl-name="flights:find flights"
      data-acdl-action="flight search initiation:flights search"
      data-acdl-page-section="header:book:flights"
      (keypress)="$event.key === 'Enter' && findFlight.emit()"
      (click)="onFindFlightClick(findFlightButton)"
      (keypress)="$event.key === 'Enter' && onFindFlightClick(findFlightButton)"
    >
      {{ bookWidgetAem.searchBtn }}
    </button>
  </div>
  <div class="flex justify-between">
    <div class="flex flex-wrap gap-x-32 gap-y-24">
      <div
        class="flex items-center gap-12"
        *ngIf="!bookWidgetFields.shopMilesField.hide"
      >
        <input
          #shopWithMilesCheckboxElement
          type="checkbox"
          id="shopWithMiles"
          class="checkbox"
          [disabled]="bookWidgetFields.shopMilesField.disable"
          [attr.aria-label]="bookWidgetAem.shopMilesField.shopWithMiles"
          [checked]="bookWidgetFields.shopMilesField.checked"
          [disabled]="bookWidgetFields.shopMilesField.disable"
          (change)="
            onCheckBoxChange($event, bookWidgetFieldUpdateTypes.shopMiles);
            !bookWidgetFields.shopMilesField.checked
              ? analyticsEvent.emit({ el: shopWithMilesCheckboxElement })
              : false
          "
        />
        <label
          for="shopWithMiles"
          class="text-label-sm-medium text-static mb-0 cursor-pointer"
          [ngClass]="{
            '!text-disabled !cursor-default':
              bookWidgetFields.shopMilesField.disable
          }"
        >
          {{ bookWidgetAem.shopMilesField.shopWithMiles }}
        </label>
      </div>
      <div
        class="flex items-center gap-12"
        *ngIf="!bookWidgetFields.flexDatesField.hide"
      >
        <input
          #flexibleDateElement
          type="checkbox"
          id="flexibleDate"
          class="checkbox"
          [attr.aria-label]="bookWidgetAem.flexDatesField.flexDates"
          [checked]="bookWidgetFields.flexDatesField.checked"
          [disabled]="bookWidgetFields.flexDatesField.disable"
          (change)="
            onCheckBoxChange($event, bookWidgetFieldUpdateTypes.flexDates);
            !bookWidgetFields.flexDatesField.checked
              ? analyticsEvent.emit({ el: flexibleDateElement })
              : false
          "
        />
        <label
          for="flexibleDate"
          class="text-label-sm-medium text-static mb-0 cursor-pointer"
          [ngClass]="{
            '!text-disabled !cursor-default':
              bookWidgetFields.flexDatesField.disable
          }"
        >
          {{ bookWidgetAem.flexDatesField.flexDates }}
        </label>
      </div>
      <div
        class="flex items-center gap-12"
        *ngIf="!bookWidgetFields.basicFaresField.hide"
      >
        <input
          #excludeBasicCheckboxElement
          type="checkbox"
          id="basicFaresField"
          class="checkbox"
          [attr.aria-label]="bookWidgetAem.includeBasicField.includeBasic"
          [checked]="bookWidgetFields.basicFaresField.checked"
          [disabled]="bookWidgetFields.basicFaresField.disable"
          (change)="
            onCheckBoxChange($event, bookWidgetFieldUpdateTypes.basicFares);
            !bookWidgetFields.basicFaresField.checked
              ? analyticsEvent.emit({ el: excludeBasicCheckboxElement })
              : false
          "
        />
        <label
          for="basicFaresField"
          class="text-label-sm-medium text-static mb-0 cursor-pointer"
          [ngClass]="{
            '!text-disabled !cursor-default':
              bookWidgetFields.basicFaresField.disable
          }"
        >
          {{ bookWidgetAem.includeBasicField.includeBasic }}
        </label>
      </div>
      <div
        class="flex items-center gap-2 flex-row-reverse"
        *ngIf="!bookWidgetFields.refundableFareField.hide"
      >
        <div class="w-[24px] h-[24px] p-[3px]">
          <img
            class="grayscale-effect"
            src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/alert-icon-help.svg"
            [attr.aria-label]="
              bookWidgetAem.refundableFareField.refundableOnly +
              ' ' +
              bookWidgetAem.helpIconAriaLabel
            "
            role="button"
            tabindex="0"
            data-acdl-action="widget:refundable fares only tooltip click"
            data-acdl-page-section="header:search widget"
            (click)="
              infoIconClickHandler(
                bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY,
                $event
              )
            "
            (keypress)="
              $event.key === 'Enter' &&
                infoIconClickHandler(
                  bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY,
                  $event
                )
            "
          />
        </div>
        <div class="flex items-center gap-12">
          <input
            #refundableFaresCheckboxElement
            type="checkbox"
            class="checkbox"
            id="showExtraFareOnly"
            [attr.aria-label]="bookWidgetAem.refundableFareField.refundableOnly"
            [disabled]="bookWidgetFields.refundableFareField.disable"
            [checked]="bookWidgetFields.refundableFareField.checked"
            (change)="
              onCheckBoxChange(
                $event,
                bookWidgetFieldUpdateTypes.refundableFare
              );
              !bookWidgetFields.refundableFareField.checked
                ? analyticsEvent.emit({ el: refundableFaresCheckboxElement })
                : false
            "
          />
          <label
            for="showExtraFareOnly"
            class="text-label-sm-medium text-static mb-0 cursor-pointer"
            [ngClass]="{
              '!text-disabled !cursor-default':
                bookWidgetFields.refundableFareField.disable
            }"
          >
            {{ bookWidgetAem.refundableFareField.refundableOnly }}
          </label>
        </div>
      </div>
      <div
        class="ultrawide:hidden flex items-center"
        *ngIf="
          isAdvancedSearchExpanded && !bookWidgetFields.flexAirportsField.hide
        "
      >
        <ng-container
          [ngTemplateOutlet]="flexAirportsCheckboxTemplate"
        ></ng-container>
      </div>
    </div>

    <a
      #advanceSearchLinkElement
      role="button"
      tabindex="0"
      class="link link-sm self-start flex-shrink-0"
      (click)="
        toggleAdvSearchExpandedEvent.emit();
        analyticsEvent.emit({ el: advanceSearchLinkElement })
      "
      (keypress)="
        $event.key === 'Enter' && toggleAdvSearchExpandedEvent.emit();
        analyticsEvent.emit({ el: advanceSearchLinkElement, event: $event })
      "
    >
      <span class="link-sort-filter-icon"></span>
      {{ bookWidgetAem.advancedSearchBtn }}
      <span
        class="transition-transform duration-200 ease-out"
        [ngClass]="
          isAdvancedSearchExpanded
            ? 'link-arrow-icon-expanded'
            : 'link-arrow-icon-collapsed'
        "
      ></span>
    </a>
  </div>
  <div class="flex gap-32 justify-between" *ngIf="isAdvancedSearchExpanded">
    <div
      class="hidden ultrawide:flex items-center"
      *ngIf="!bookWidgetFields.flexAirportsField.hide"
    >
      <ng-container
        [ngTemplateOutlet]="flexAirportsCheckboxTemplate"
      ></ng-container>
    </div>

    <div class="flex gap-12">
      <div
        *ngIf="!bookWidgetFields.bestFareOptionsField.hide"
        class="w-[278.68px]"
      >
        <idp-best-fare-options-mach-core
          [title]="bookWidgetAem.bestFareOptionsField.bestFare"
          [disabled]="bookWidgetFields.bestFareOptionsField.disable"
          [infoModalContent]="bookWidgetAem.bestFareOptionsField.infoModal"
          [dropdownOptions]="
            bookWidgetFields.bestFareOptionsField.dropdownOptions
          "
          [infoTooltipOptions]="{
            positions: 'bottom-left',
            color: 'high-contrast',
            triggerEvent: 'toggle'
          }"
          (bestFareOptionsChange)="
            onDropdownSelectionChange(
              $event,
              bookWidgetFieldUpdateTypes.bestFareOptions
            )
          "
        ></idp-best-fare-options-mach-core>
      </div>
      <div
        *ngIf="!bookWidgetFields.meetingEventCodeField.hide"
        class="w-[278.67px]"
      >
        <idp-meeting-code-mach-core
          [placeholder]="bookWidgetAem.meetingEventCodeField.placeholder"
          [title]="bookWidgetAem.meetingEventCodeField.meetingEventCode"
          [value]="bookWidgetFields.meetingEventCodeField.meetingEventCodeValue"
          [disabled]="bookWidgetFields.meetingEventCodeField.disable"
          [infoModalContent]="bookWidgetAem.meetingEventCodeField.infoModal"
          [errorMessage]="
            bookWidgetFields.meetingEventCodeField.fieldErrorInfo?.errorMessage
          "
          [tooltipOptions]="{
            positions: 'bottom-left',
            color: 'high-contrast',
            triggerEvent: 'toggle'
          }"
          [disclaimerMessage]="
            bookWidgetFields.meetingEventCodeField.disclaimerMessage
          "
          (valueChange)="
            onInputFieldChange(
              $event,
              bookWidgetFieldUpdateTypes.meetingEventCode
            )
          "
        ></idp-meeting-code-mach-core>
      </div>
    </div>
    <ng-container *ngIf="!bookWidgetFields.edocsLink.hide">
      <a
        #edocsLinkElement
        [href]="bookWidgetFields.edocsLink.src"
        class="self-center link link-md justify-self-end ml-auto text-right"
        (click)="analyticsEvent.emit({ el: edocsLinkElement })"
      >
        {{ bookWidgetAem.edocsLink }}
      </a>
    </ng-container>
  </div>

  <ng-template #flexAirportsCheckboxTemplate>
    <div
      class="flex items-center gap-12"
      *ngIf="!bookWidgetFields.flexAirportsField.hide"
    >
      <input
        #flexAirportsCheckbox
        type="checkbox"
        id="includeNearByAirport"
        class="checkbox"
        [attr.aria-label]="bookWidgetAem.flexAirportsField.flexAirports"
        [checked]="bookWidgetFields.flexAirportsField.checked"
        [disabled]="bookWidgetFields.flexAirportsField.disable"
        (change)="
          onCheckBoxChange($event, bookWidgetFieldUpdateTypes.flexAirport);
          !bookWidgetFields.flexAirportsField.checked
            ? analyticsEvent.emit({ el: flexAirportsCheckbox })
            : false
        "
      />
      <label
        for="includeNearByAirport"
        class="text-label-sm-medium text-static mb-0 cursor-pointer"
        [ngClass]="{
          '!text-disabled !cursor-default':
            bookWidgetFields.flexAirportsField.disable
        }"
      >
        {{ bookWidgetAem.flexAirportsField.flexAirports }}
      </label>
    </div>
  </ng-template>
</div>
